import { render, staticRenderFns } from "./style-five.vue?vue&type=template&id=65c16dc3&scoped=true&"
import script from "./style-five.vue?vue&type=script&lang=js&"
export * from "./style-five.vue?vue&type=script&lang=js&"
import style0 from "./style-five.vue?vue&type=style&index=0&id=65c16dc3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c16dc3",
  null
  
)

export default component.exports